import { elements } from '@elements';

const cloneElement = nodeType => structuredClone(elements[nodeType].node);
export default cloneElement;
